import React from 'react';
import TestimonialList from '@/components/TestimonialCarousel/TestimonialList';
import { Trustbar2 } from '@/components/Trustbar2';
import TwoCol from '@/components/Subscription/TwoCol';
import FAQSection from '@/components/FAQ/FAQSection';

const BottomSection = ({ components }) => {
    console.log('testimonials', components[0].testimonials);
    return (
        <section>
            <TestimonialList testimonials={components[0].testimonials} />

            {/*
            <div className='pb-[40px] mt-10 sm:mb-16'>
                <Trustbar2
                    className=''
                    logos={components[1].gallery}
                    phoneImageMaxWidth='80px'
                    flexWrap='wrap'
                />
            </div>
            */}

            <div className='hidden lg:block mt-10'>
                <Trustbar2
                    logos={components[2].gallery}
                    className='center-on-medium grayscale'
                    mediumImageMaxWidth='25%'
                    phoneImageMaxWidth='30%'
                />
            </div>

            <TwoCol
                heading={components[3].heading}
                featuredImage={components[3].featuredImage}
            />

            <div className='block lg:hidden default-py mb-10'>
                <Trustbar2
                    logos={components[2].gallery}
                    className='center-on-medium grayscale'
                    mediumImageMaxWidth='25%'
                    phoneImageMaxWidth='30%'
                />
            </div>

            <FAQSection faqs={components[4].faqQuestion} />

        </section>
    );
};

export default BottomSection;
